import { render, staticRenderFns } from "./TestQueryResolutionList.vue?vue&type=template&id=15643987&scoped=true&"
import script from "./TestQueryResolutionList.vue?vue&type=script&lang=js&"
export * from "./TestQueryResolutionList.vue?vue&type=script&lang=js&"
import style0 from "./TestQueryResolutionList.vue?vue&type=style&index=0&id=15643987&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15643987",
  null
  
)

export default component.exports